var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartPensionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    viewBox: "0 0 218 218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.295 0C48.9352 0 0 48.803 0 109C0 169.197 48.9352 218 109.295 218C169.655 218 218.59 169.201 218.59 109C218.59 48.7988 169.659 0 109.295 0ZM143.117 122.51C128.174 152.945 96.7048 174.63 60.2532 180.727C57.9093 181.119 57.0426 177.768 59.2798 176.963C73.1978 171.947 100.12 158.229 113.85 136.582C124.9 120.432 131.735 88.4688 63.8394 95.6134C61.6279 95.8476 60.6673 92.369 62.708 91.5046C84.4176 82.3248 100.966 80.4769 117.578 80.2768C137.345 80.4727 159.746 89.9463 143.117 122.51ZM144.731 72.3573C136.013 72.3573 128.934 64.574 128.934 54.9726C128.934 45.3713 136 37.5837 144.731 37.5837C153.461 37.5837 160.527 45.367 160.527 54.9726C160.527 64.5782 153.427 72.3573 144.731 72.3573Z",
    fill: "#002945"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartPensionLogo);
export default __webpack_public_path__ + "static/media/smart-pension-logo.3082537a2fb4b16219ac2fb3ae9c9aea.svg";
export { ForwardRef as ReactComponent };